<h1>Mes modèles de bases de données</h1>
@if ((modelIsEmpty$ | async) === false) {
  @if (model$ | async; as model) {
    <section>
      <h2>En cours</h2>
      @if(model !== null && model.getId() !== undefined && (model.getId() > 0)) {
        <a href="/database-model/{{model.getId()}}">{{model.getTitle()}}</a>
      } @else {
        <a href="/database-model/-1">{{model.getTitle()}}</a>
      }
    </section>
  }
}

<section>
  <h2>Modèles sauvegardés</h2>
  @if ((allModels$ | async)?.length) {
    @for (model of allModels$ | async; track $index) {
      <article>
        <a href="/database-model/{{model.id}}">{{model.title}}</a>

        <button class="warning" (click)="delete(model.id)" type="button">
          <svg-trash></svg-trash>
supprimer
        </button>
      </article>
    }
  } @else {
    <p>Il n'y a pas encore de modèle de base de données</p>
  }

    @if (modelIsEmpty$ | async) {

      <app-button [text]="'Créer un nouveau modèle de base de données'" [link]="'/database-model/0'"></app-button>
    } @else {
      <!-- TODO : ajouter une modal expliquant que le modèle <nom du modèle> sera écrasé si non sauvegardé -->
      <app-button [text]="'Créer un nouveau modèle de base de données'" [link]="'/database-model/0'"></app-button>
    }

</section>
